var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2302_1403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0774 4.59338C15.9977 4.55065 15.9079 4.53034 15.8175 4.53464C15.7271 4.53893 15.6396 4.56766 15.5643 4.61776L13.3418 6.09651V4.53088C13.3418 4.26567 13.2364 4.01131 13.0489 3.82378C12.8614 3.63624 12.607 3.53088 12.3418 3.53088H2.3418C2.07658 3.53088 1.82223 3.63624 1.63469 3.82378C1.44715 4.01131 1.3418 4.26567 1.3418 4.53088V11.5309C1.3418 11.7961 1.44715 12.0505 1.63469 12.238C1.82223 12.4255 2.07658 12.5309 2.3418 12.5309H12.3418C12.607 12.5309 12.8614 12.4255 13.0489 12.238C13.2364 12.0505 13.3418 11.7961 13.3418 11.5309V9.96838L15.5643 11.4503C15.6468 11.5039 15.7434 11.5319 15.8418 11.5309C15.9744 11.5309 16.1016 11.4782 16.1954 11.3844C16.2891 11.2907 16.3418 11.1635 16.3418 11.0309V5.03088C16.3412 4.94092 16.3163 4.85279 16.2697 4.77579C16.2232 4.6988 16.1568 4.63578 16.0774 4.59338ZM12.3418 11.5309H2.3418V4.53088H12.3418V11.5309ZM15.3418 10.0965L13.3418 8.76338V7.29838L15.3418 5.96838V10.0965Z",
    fill: "#1C1D21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2302_1403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.341797 0.0308838)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.53ab9272397a0b8230a225a6bcabaeda.svg";
export { ForwardRef as ReactComponent };